export default {
    OVERTIME: '连接超时，请稍后再试',
    BUSY_SERVICE: '服务器繁忙，请稍后再试',
    REQUEST_FAIL: '服务器无响应，请稍后再试'
}



// WEBPACK FOOTER //
// ./src/assets/config/cue_config.js